
export const RING_ALIGN = {
  large: { columnWidth: 160, inset: 14, barLabelWidth: 150, chartGap: 28, labelBarGap: 8 },
  small: { columnWidth: 104, inset: 12, barLabelWidth: 92, chartGap: 14, labelBarGap: 8 },
};

export function barTrackStart(size) {
  const a = RING_ALIGN[size] ?? RING_ALIGN.large;
  return a.columnWidth + a.chartGap + a.barLabelWidth + a.labelBarGap;
}
